module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./CourseView.js"));
	}, "CourseView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CourseView!./src/pages/Learn/Course/CourseView.js
// module id = 1737
// module chunks = 418